// Lista dostepnych zmiennych/placeholderow dla szablonow wydruku.
//
// SYNCHRONIZACJA Z BACKENDEM (sierpien 2026): lista odpowiada slownikowi
// podstawien z backend/api/custom_templates.py (funkcja replace_placeholders
// podmienia WYLACZNIE klucze z tego slownika, a nieznane wzorce zostawia
// doslownie na wydruku).
//
// Co sie zmienilo i dlaczego:
//  - DODANE {numer_korekty} i {numer_zwrotu} - sciezka zwrotu podaje te dane,
//    ale bez podpowiedzi nikt ich nie uzywal, a szablon korekty drukowal
//    doslownie tekst '{numer_korekty}'.
//  - DODANE warianty dwuklamrowe {{...}} dla paragonu i zwrotu - tylko w tej
//    formie dzialaja podstawienia specyficzne dla paragonu (kasjer, sklep,
//    data transakcji, powod zwrotu). Wczesniej nie bylo ich na zadnej liscie.
//  - USUNIETE zmienne, ktorych backend NIE PODSTAWIA (m.in. {vat_23_netto},
//    {kwota_slownie}, {status_platnosci}, {uwagi}, {waluta}, {rok}, {miesiac},
//    {dzien}, {sprzedawca_telefon}, {nabywca_email}). Podpowiadanie ich
//    konczylo sie surowym tekstem w klamrach na dokumencie dla klienta.
//    Zamiast {kwota_slownie} jest {suma_brutto_slownie}.
export const availableVariables = [
  // Podstawowe dane faktury
  { name: '{numer_faktury}', description: 'Numer faktury' },
  { name: '{numer_paragonu}', description: 'Numer paragonu' },
  { name: '{numer_korekty}', description: 'Numer korekty paragonu' },
  { name: '{numer_zwrotu}', description: 'Numer zwrotu do paragonu' },
  { name: '{paragon_info}', description: 'Linia „Do paragonu: ...” (pusta, gdy brak)' },
  { name: '{data_wystawienia}', description: 'Data wystawienia' },
  { name: '{data_sprzedazy}', description: 'Data sprzedaży' },
  { name: '{termin_platnosci}', description: 'Termin płatności' },
  { name: '{forma_platnosci}', description: 'Forma płatności' },

  // Dokumenty korygujace
  { name: '{typ_faktury}', description: 'Typ faktury (sprzedaż / korekta)' },
  { name: '{faktura_oryginalna_numer}', description: 'Numer faktury korygowanej' },
  { name: '{faktura_oryginalna_id}', description: 'Identyfikator faktury korygowanej' },
  { name: '{przyczyna_korekty}', description: 'Przyczyna korekty' },

  // Dane sprzedawcy
  { name: '{sprzedawca_nazwa}', description: 'Nazwa sprzedawcy' },
  { name: '{sprzedawca_adres}', description: 'Adres sprzedawcy' },
  { name: '{sprzedawca_miasto}', description: 'Miasto sprzedawcy' },
  { name: '{sprzedawca_kod_pocztowy}', description: 'Kod pocztowy sprzedawcy' },
  { name: '{sprzedawca_nip}', description: 'NIP sprzedawcy' },
  { name: '{sprzedawca_bank}', description: 'Bank sprzedawcy' },
  { name: '{sprzedawca_nr_konta}', description: 'Numer konta sprzedawcy' },

  // Dane nabywcy
  { name: '{nabywca_nazwa}', description: 'Nazwa nabywcy' },
  { name: '{nabywca_adres}', description: 'Adres nabywcy' },
  { name: '{nabywca_miasto}', description: 'Miasto nabywcy' },
  { name: '{nabywca_kod_pocztowy}', description: 'Kod pocztowy nabywcy' },
  { name: '{nabywca_nip}', description: 'NIP nabywcy' },

  // Dane odbiorcy (domyslnie kopia nabywcy)
  { name: '{odbiorca_nazwa}', description: 'Nazwa odbiorcy' },
  { name: '{odbiorca_adres}', description: 'Adres odbiorcy' },
  { name: '{odbiorca_miasto}', description: 'Miasto odbiorcy' },
  { name: '{odbiorca_kod_pocztowy}', description: 'Kod pocztowy odbiorcy' },
  { name: '{odbiorca_nip}', description: 'NIP odbiorcy' },

  // Podsumowania finansowe
  { name: '{suma_netto}', description: 'Suma netto' },
  { name: '{suma_vat}', description: 'Suma VAT (całkowita)' },
  { name: '{suma_brutto}', description: 'Suma brutto' },
  { name: '{suma_brutto_slownie}', description: 'Suma brutto słownie' },
  { name: '{suma_brutto_przed_rabatem}', description: 'Suma brutto przed rabatem' },
  { name: '{rabat_kwota}', description: 'Kwota rabatu' },
  { name: '{rabat_procent}', description: 'Rabat w procentach' },
  { name: '{zaplacono}', description: 'Kwota zapłacona' },
  { name: '{pozostaje}', description: 'Pozostaje do zapłaty' },

  // Paragon i zwrot - WYLACZNIE w wariancie dwuklamrowym
  { name: '{{numer_paragonu}}', description: 'Paragon: numer paragonu' },
  { name: '{{numer_korekty}}', description: 'Paragon: numer korekty' },
  { name: '{{numer_zwrotu}}', description: 'Paragon: numer zwrotu' },
  { name: '{{paragon_zrodlowy}}', description: 'Zwrot: numer paragonu źródłowego' },
  { name: '{{powod_zwrotu}}', description: 'Zwrot: powód zwrotu' },
  { name: '{{data_zwrotu}}', description: 'Zwrot: data' },
  { name: '{{czas_zwrotu}}', description: 'Zwrot: godzina' },
  { name: '{{data_transakcji}}', description: 'Paragon: data transakcji' },
  { name: '{{metoda_platnosci}}', description: 'Paragon: metoda płatności' },
  { name: '{{location_name}}', description: 'Paragon: nazwa sklepu' },
  { name: '{{kasjer_imie}}', description: 'Paragon: imię kasjera' },
  { name: '{{suma_brutto}}', description: 'Paragon: suma brutto' },
  { name: '{{suma_netto}}', description: 'Paragon: suma netto' },
  { name: '{{suma_vat}}', description: 'Paragon: suma VAT' },
  { name: '{{rabat_kwota}}', description: 'Paragon: kwota rabatu' },
  { name: '{{rabat_procent}}', description: 'Paragon: rabat w procentach' },
  { name: '{{suma_brutto_przed_rabatem}}', description: 'Paragon: suma brutto przed rabatem' }
];

// Domyslna konfiguracja nowego pola
export const DEFAULT_FIELD = {
  type: "text",
  x: 50,
  y: 50,
  width: 200,
  height: 20,
  content: "Nowe pole",
  contentLines: ["Nowe pole"],
  style: {
    fontSize: 12,
    fontWeight: "normal",
    textAlign: "left",
    color: "#000000"
  }
};

// Domyslna konfiguracja tabeli
export const DEFAULT_TABLE_CONFIG = {
  columns: [
    { name: 'Lp.', width: 50, align: 'center', dataField: 'lp' },
    { name: 'Nazwa produktu', width: 200, align: 'left', dataField: 'nazwa_produktu' },
    { name: 'Ilosc', width: 60, align: 'center', dataField: 'ilosc' },
    { name: 'Cena jedn.', width: 100, align: 'right', dataField: 'cena_jednostkowa_netto' },
    { name: 'Wartosc', width: 100, align: 'right', dataField: 'wartosc_brutto' }
  ],
  rowHeight: 20,
  fontSize: 10,
  headerFontSize: 12,
  lineWidth: 0.5,
  showHeader: true,
  showBorders: true
};

// Domyslne ustawienia szablonu
export const DEFAULT_TEMPLATE_SETTINGS = {
  page_size: "A4",
  margins: { top: 50, bottom: 50, left: 50, right: 50 },
  font_family: "Arial",
  font_size: 10,
  text_case: "normal"
};

// Symulowane dane faktury do podgladu
export const MOCK_INVOICE_DATA = {
  invoice_number: "FAK/2025/001",
  invoice_date: "2025-09-05",
  due_date: "2025-09-20",
  buyer: {
    name: "Klient XYZ",
    address: "ul. Testowa 456",
    city: "50-001 Wroclaw",
    nip: "0987654321"
  },
  items: [
    {
      name: "Produkt A",
      quantity: 2,
      unit_price: 100.00,
      total: 200.00
    },
    {
      name: "Produkt B",
      quantity: 1,
      unit_price: 150.00,
      total: 150.00
    }
  ],
  total_net: 350.00,
  vat_amount: 80.50,
  total_gross: 430.50
};
